import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ClinicSignin from "@/pages/ClinicSignin";
import ClinicSignup from "@/pages/ClinicSignup";
import appConfig from "@/config/appConfig";

function RedirectToRealDashboard() {
  // Configurable target URL for the real app's admin dashboard
  const target = appConfig.dashboardUrl;
  if (typeof window !== 'undefined') {
    window.location.replace(target);
  }
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/signin" replace />} />
          <Route path="/signin" element={<ClinicSignin />} />
          <Route path="/signup" element={<ClinicSignup />} />
          <Route path="/admin-dashboard" element={<RedirectToRealDashboard />} />
          <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
